module.exports = __webpack_public_path__ + "h5/static/img/bit-bank-logo.daaed141.png";